"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = exports.setCookie = exports.MimoblCookieValue = exports.MimoblCookie = void 0;
var MimoblCookie;
(function (MimoblCookie) {
    MimoblCookie["USER_REFERRER"] = "uref";
    MimoblCookie["SEEN_SERVICE_OFFERING_MODAL"] = "ssom";
    MimoblCookie["LOCATION_SUBSCRIPTION_INVITE"] = "lsi";
    MimoblCookie["SEEN_SURVEY_MODAL"] = "ssm";
})(MimoblCookie = exports.MimoblCookie || (exports.MimoblCookie = {}));
var MimoblCookieValue;
(function (MimoblCookieValue) {
    MimoblCookieValue["SEEN_SURVEY_MODAL_COMPLETED"] = "completed";
    MimoblCookieValue["SEEN_SURVEY_MODAL_REJECTED"] = "rejected";
})(MimoblCookieValue = exports.MimoblCookieValue || (exports.MimoblCookieValue = {}));
const setCookie = (name, value, ttlDays) => {
    const d = new Date;
    d.setTime(d.getTime() + ttlDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
};
exports.setCookie = setCookie;
const getCookie = (name) => {
    const key = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(key) === 0) {
            return c.substring(key.length, c.length);
        }
    }
    return null;
};
exports.getCookie = getCookie;
